// Theme: nord
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'nord',
  name: 'NORD',
  tagline: 'NORD',
  description: 'Nord clean. Polar night muted, sem bordas evidentes e leitura suave.',
  category: 'system-core',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#2F3440', '#3A404D', '#7D93AD', '#E8ECF2'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '16px',
      '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
      '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)'
    },
    shellClasses: 'font-sans theme-nord'
  },
  colorVars: {
    '--accent': '#7D93AD',
    '--accent-foreground': '#2F3440',
    '--background': '#2F3440',
    '--border': '#434A58',
    '--card': '#3A404D',
    '--card-border-active': 'rgba(125, 147, 173, 0.10)',
    '--card-completed': '#353B47',
    '--card-foreground': '#E8ECF2',
    '--card-glow': 'rgba(125, 147, 173, 0.03)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#2F3440',
    '--foreground': '#E8ECF2',
    '--hold-fill': '#7D93AD',
    '--input': '#434A58',
    '--modal-bg': '#2F3440',
    '--modal-border': '#434A58',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#434A58',
    '--muted-foreground': '#D9DFE8',
    '--nav-active': '#7D93AD',
    '--nav-bg': '#3A404D',
    '--popover': '#3A404D',
    '--popover-foreground': '#E8ECF2',
    '--primary': '#7D93AD',
    '--primary-foreground': '#2F3440',
    '--ring': '#7D93AD',
    '--secondary': '#434A58',
    '--secondary-foreground': '#E8ECF2',
    '--streak': '#7D93AD',
    '--success': '#22c55e',
    '--success-foreground': '#2F3440',
    '--xp': '#7D93AD',
    '--xp-bg': '#3A404D'
  },
  resolvedVars: {
    '--accent': '#7D93AD',
    '--accent-foreground': '#2F3440',
    '--accent-foreground-hsl': '222 15% 22%',
    '--accent-foreground-oklch': 'from #2F3440 l c h',
    '--accent-hsl': '213 23% 58%',
    '--accent-oklch': 'from #7D93AD l c h',
    '--background': '#2F3440',
    '--background-hsl': '222 15% 22%',
    '--background-oklch': 'from #2F3440 l c h',
    '--border': '#434A58',
    '--border-hsl': '220 14% 30%',
    '--border-oklch': 'from #434A58 l c h',
    '--border-w': '1px',
    '--card': '#3A404D',
    '--card-border-active': 'rgba(125, 147, 173, 0.10)',
    '--card-completed': '#353B47',
    '--card-completed-hsl': '220 15% 24%',
    '--card-completed-oklch': 'from #353B47 l c h',
    '--card-foreground': '#E8ECF2',
    '--card-foreground-hsl': '216 28% 93%',
    '--card-foreground-oklch': 'from #E8ECF2 l c h',
    '--card-glow': 'rgba(125, 147, 173, 0.03)',
    '--card-hsl': '221 14% 26%',
    '--card-oklch': 'from #3A404D l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#2F3440',
    '--destructive-foreground-hsl': '222 15% 22%',
    '--destructive-foreground-oklch': 'from #2F3440 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#E8ECF2',
    '--foreground-hsl': '216 28% 93%',
    '--foreground-oklch': 'from #E8ECF2 l c h',
    '--hold-fill': '#7D93AD',
    '--hold-fill-hsl': '213 23% 58%',
    '--hold-fill-oklch': 'from #7D93AD l c h',
    '--input': '#434A58',
    '--input-hsl': '220 14% 30%',
    '--input-oklch': 'from #434A58 l c h',
    '--modal-bg': '#2F3440',
    '--modal-bg-hsl': '222 15% 22%',
    '--modal-bg-oklch': 'from #2F3440 l c h',
    '--modal-border': '#434A58',
    '--modal-border-hsl': '220 14% 30%',
    '--modal-border-oklch': 'from #434A58 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#434A58',
    '--muted-foreground': '#D9DFE8',
    '--muted-foreground-hsl': '216 25% 88%',
    '--muted-foreground-oklch': 'from #D9DFE8 l c h',
    '--muted-hsl': '220 14% 30%',
    '--muted-oklch': 'from #434A58 l c h',
    '--nav-active': '#7D93AD',
    '--nav-active-hsl': '213 23% 58%',
    '--nav-active-oklch': 'from #7D93AD l c h',
    '--nav-bg': '#3A404D',
    '--nav-bg-hsl': '221 14% 26%',
    '--nav-bg-oklch': 'from #3A404D l c h',
    '--popover': '#3A404D',
    '--popover-foreground': '#E8ECF2',
    '--popover-foreground-hsl': '216 28% 93%',
    '--popover-foreground-oklch': 'from #E8ECF2 l c h',
    '--popover-hsl': '221 14% 26%',
    '--popover-oklch': 'from #3A404D l c h',
    '--primary': '#7D93AD',
    '--primary-foreground': '#2F3440',
    '--primary-foreground-hsl': '222 15% 22%',
    '--primary-foreground-oklch': 'from #2F3440 l c h',
    '--primary-hsl': '213 23% 58%',
    '--primary-oklch': 'from #7D93AD l c h',
    '--radius': '16px',
    '--ring': '#7D93AD',
    '--ring-hsl': '213 23% 58%',
    '--ring-oklch': 'from #7D93AD l c h',
    '--secondary': '#434A58',
    '--secondary-foreground': '#E8ECF2',
    '--secondary-foreground-hsl': '216 28% 93%',
    '--secondary-foreground-oklch': 'from #E8ECF2 l c h',
    '--secondary-hsl': '220 14% 30%',
    '--secondary-oklch': 'from #434A58 l c h',
    '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)',
    '--streak': '#7D93AD',
    '--streak-hsl': '213 23% 58%',
    '--streak-oklch': 'from #7D93AD l c h',
    '--success': '#22c55e',
    '--success-foreground': '#2F3440',
    '--success-foreground-hsl': '222 15% 22%',
    '--success-foreground-oklch': 'from #2F3440 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(213 23% 58% / 0.15)',
    '--xp': '#7D93AD',
    '--xp-bg': '#3A404D',
    '--xp-bg-hsl': '221 14% 26%',
    '--xp-bg-oklch': 'from #3A404D l c h',
    '--xp-hsl': '213 23% 58%',
    '--xp-oklch': 'from #7D93AD l c h'
  }
}
